import {
  useGetTrainingTasksApiV1TrainingTasksGet,
  useModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch,
} from "../../../../vl-api/vlComponents";
import { App } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateActiveQueryByOperationId } from "../../../../vl-api/vlUtils";
import last from "lodash/last";
import { TrainingTask } from "../../../../vl-api/vlSchemas";
import { isActiveTask } from "./modelJobsUtils";

const POLLING_INTERVAL_MS = 2000;

export const useTrainingTasks = (datasetId: string) => {
  const { notification, modal } = App.useApp();
  const queryClient = useQueryClient();
  const { data, isLoading, isError } =
    useGetTrainingTasksApiV1TrainingTasksGet<{
      tasks: any[];
    }>(
      {
        queryParams: { dataset_id: datasetId },
      },
      {
        refetchInterval: ({ state }) => {
          if (isActiveTask(last(state.data?.tasks))) {
            return POLLING_INTERVAL_MS;
          }
        },
      },
    );
  const modelTrainingActionsMutation =
    useModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch({
      onSuccess: () => {
        notification.success({ message: "Training aborted" });
        invalidateActiveQueryByOperationId(
          queryClient,
          "getTrainingTasksApiV1TrainingTasksGet",
        );
      },
    });
  const handleCancelTaskClick = (taskId: string) => {
    modal.confirm({
      title: "Abort training?",
      content: "The training job will stop and can't be resumed.",
      okText: "Yes",
      okButtonProps: { danger: true },
      onOk: () =>
        modelTrainingActionsMutation.mutate({
          pathParams: { trainingTaskId: taskId },
          queryParams: { action: "CANCEL" },
        }),
      cancelText: "No",
    });
  };

  return {
    handleCancelTaskClick,
    task: last<TrainingTask>(data?.tasks),
    tasks: (data?.tasks ?? []) as TrainingTask[],
    isLoading,
    isError,
  };
};
